import {
    AlertProvider,
    Button,
    DataGrid,
    DataGridColumn,
    DataGridSection, Header, mergeRows, Modal, Spinner
} from "acma-spa";
import React, { useEffect, useState } from "react";
import { FileParameter, getApiClient } from "../api";
import { ProgressStageProps, SPAMComplaint, SPAMComplaintMessage, SPAMComplaintMessageType } from "../models/Models";
import { Message } from "./message";
import { NextPreviousButtons } from "./next-previous-buttons";

export interface MessageDetailsProps extends ProgressStageProps {
    baseUrl: string;
}

export const MessageDetails = (props: MessageDetailsProps) => {

    const MAX_ROWS = 5;
    const [error, setError] = useState<Error>(null);
    const [rows, setRows] = useState<SPAMComplaintMessage[]>(props.submission.messages || []);
    const columns: DataGridColumn<SPAMComplaintMessage>[] = [
        {
            label: "Date",
            value: (r) => r.messageDate.toLocaleDateString()
        },
        {
            label: "Type",
            value: (r) => r.messageType.toString()
        },
        {
            label: "File",
            value: (r) => r.fileName
        },
        {
            label: "",
            rightAlign: true,
            value: (r) =>
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        if (confirm("Are you sure you want to remove this message?")) {
                            const newRows = mergeRows(rows, r, null);
                            setRows(newRows);
                        }
                    }}
                >
                    Remove
                </a>

        },
    ];

    useEffect(() => {
        if (props.onChange && rows !== props.submission.messages) {
            props.onChange(SPAMComplaint.fromJS({ ...props.submission, messages: rows }));
            setError(null);
        }
        
    }, [rows])

    const handleSubmit = async () => {
        setError(null);
        if (rows.length === 0) {
            setError(error instanceof Error ? error : new Error(`Please add at least one message`));
            return;
        }

        try {
            setLoading(true);
            const [client, abort] = getApiClient(props.baseUrl);
            let fileParams = props.submission.messages?.filter(i => typeof (i.fileId) !== "undefined").map(i => {
                let fileParameter: FileParameter = { data: i.file, fileName: i?.fileId + "_" + i?.fileName };
                return fileParameter;
            });

            let result = await client.complaints(fileParams, JSON.stringify(props.submission));
            if (result && props.onNext) {
                props.onNext();
            }
        } catch (error) {
            setError(error instanceof Error ? error : new Error(`Error submitting complaint`));
        } finally {
            setLoading(false);
        }
    }
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [expanded, setExpanded] = useState<(SPAMComplaint | null)[]>([]);
    return (<>
        <Spinner isLoading={loading}>
        {error?.message && <AlertProvider
            messages={[
                error.message
            ]}
        />}
        <Modal open={open} onClose={() => setOpen(false)} rightButtons={[
            {
                label: "Ok",
                onClick: () => setOpen(false),
                mode: "secondary"
            }
        ]} id={"messageModal"} title={""}>
            <p><b>Maximum number of messages reached, please continue to Finish and submit</b></p>
        </Modal>
        <div className="row">
            <div className="col col-12 mb-4">
                <h3>You can add up to five messages to your complaint. Click 'Add message' to start. Once you have added your message(s), click Finish and Submit.</h3>
            </div>
        </div>
        <Header label="Messages">
            <Button label={rows.length > 0 ? "Add another message" : "Add message"} onClick={() => {
                if (rows.length < MAX_ROWS) {
                    setExpanded([null])
                } else {
                    setOpen(true);
                }
            }
            } />
        </Header>
        <DataGrid<SPAMComplaintMessage>
            columns={columns}
            rows={rows}
            noRowsMessage="Please add messages"
            expand={{
                rows: expanded,
                onChange: setExpanded,
                content: (current: SPAMComplaintMessage) => (
                    <Message
                        r={current}
                        onChange={(update) => {
                            const newRows = mergeRows(rows, current, update);
                            setRows(newRows);
                            setExpanded(expanded.filter(r => r != current));
                        }}
                        baseUrl={props.baseUrl}
                        errors={""}
                        anonymous={props.submission.anonymous}
                    />
                )
            }}
        ></DataGrid>
        <NextPreviousButtons
            edge={'last'}
            onPrevious={props.onPrevious}
            onNext={handleSubmit}
            disabled={rows.length === 0}
            />
        </Spinner>
    </>
    );
}